import {RiverBreakoutTabs, Image, Link, Text} from '@primer/react-brand/esm'
import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'

import {getImageSources} from '@github-ui/swp-core/lib/utils/images'
import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'

import {AssetTypeEnum} from '../../types'
import type {IconAssetLinkItem} from '../../types'
import {AssetVideo} from '../Video'
import {getAssetImageStyle, renderWithoutParagraphs} from '../../utils'

export type FlexSuiteRiverBreakoutTabsProps = {
  items?: IconAssetLinkItem[]
}

export const FlexSuiteRiverBreakoutTabs = ({items}: FlexSuiteRiverBreakoutTabsProps) => {
  if (!items || items.length === 0) return null

  return (
    <RiverBreakoutTabs>
      <RiverBreakoutTabs.A11yHeading>
        {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
        {documentToPlainTextString(items[0]!.fields.heading)}
      </RiverBreakoutTabs.A11yHeading>
      {items.map(item => {
        const {
          heading,
          description,
          href,
          label,
          alt,
          icon,
          assetType,
          optionImage,
          optionVideo,
          optionPoster,
          autoplay,
          videoSource,
        } = item.fields
        const imageStyle = getAssetImageStyle(optionImage)

        const Octicon = icon ? getPrimerIcon(icon) : undefined

        return (
          <RiverBreakoutTabs.Item key={item.sys.id}>
            {Octicon && <RiverBreakoutTabs.Icon icon={Octicon} color="green" />}
            <RiverBreakoutTabs.Heading>{renderWithoutParagraphs(heading)}</RiverBreakoutTabs.Heading>
            <RiverBreakoutTabs.Content>
              {description && <Text>{renderWithoutParagraphs(description)}</Text>}
              {href && label ? (
                <Link href={href} {...(alt ? {'aria-label': alt} : {})}>
                  {label}
                </Link>
              ) : null}
            </RiverBreakoutTabs.Content>
            <RiverBreakoutTabs.Visual>
              {assetType === AssetTypeEnum.enum.Image && optionImage && (
                <Image
                  as="picture"
                  aspectRatio={imageStyle ? 'custom' : undefined}
                  src={`${optionImage.fields.file.url}?fm=webp`}
                  sources={getImageSources(optionImage.fields.file.url)}
                  style={imageStyle}
                  alt={optionImage.fields.description ?? ''}
                  loading="lazy"
                />
              )}
              <AssetVideo
                assetType={assetType}
                optionVideo={optionVideo}
                optionPoster={optionPoster}
                autoplay={autoplay}
                videoSource={videoSource}
              />
            </RiverBreakoutTabs.Visual>
          </RiverBreakoutTabs.Item>
        )
      })}
    </RiverBreakoutTabs>
  )
}
